import React, { useState } from 'react';
import { email as emailValidator } from '@upgrade/ui-utils/validators';
import { Form, FormField, TextInput, Text } from '@upgrade/react-components';
import { postDepositLead } from '../../../api-internal/submit-email';
import * as Styles from '../styles';
import { getDepositUrl } from '../../../utils/get-funnel-url';

const defaultValues = {
  email: ''
};

const validators = {
  email: [emailValidator()]
};

const AccountEmailForm = ({ location, ctaButtonName, ctaButtonAriaLabel }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async ({ formValues } = {}) => {
    let result;
    let leadUuid;

    const { email } = formValues || '';

    if (email.length) {
      setIsLoading(true);
      result = await postDepositLead({ email });
      leadUuid = result?.data?.leadInfo?.leadUuid;
    }

    setIsLoading(false);
    const redirectUrl = getDepositUrl({ location, leadUuid });
    window.location.assign(redirectUrl);
  };

  return (
    <Form onSubmit={handleSubmit} {...{ validators, initialValues: defaultValues }}>
      <Styles.FormFieldExperiment className="fs-exclude">
        <Text align="left">
          <TextInput name="email" label="Enter your email" data-auto="emailField" />
        </Text>
      </Styles.FormFieldExperiment>
      <FormField>
        <Styles.CTAButtonExperiment
          emphasis="primary"
          submit
          fullWidth
          data-auto={ctaButtonName}
          loading={isLoading}
          buttonProps={{ 'aria-label': ctaButtonAriaLabel }}
        >
          Get Started
        </Styles.CTAButtonExperiment>
      </FormField>
    </Form>
  );
};

export default AccountEmailForm;
